import { RequestTypes } from '../../../hooks'

export const AUDIT_API_PREFIX = '/api/audit/v1/'
export const BILLING_API_PREFIX = '/api/billing/v1/'
export const EXTENSION_API_PREFIX = '/api/extension/v1/'

export const BILLING_CREDENTIALS = 'credentials'
export const BILLING_BALANCES = 'account-balances'
export const BILLING_PACKAGES = 'service-packages/my'
export const HISTORY_PAYMENT = 'event-history-payment-acc'
export const CREDENTIALS_DOWNLOAD = 'credentials-download'
export const PAYMENT_OPERATIONS = 'files/payment-operations'
export const CALCULATOR_TARIFFS = 'payment-tariffs-calculator'

export const getCredentials = {
    link: `${BILLING_API_PREFIX}${BILLING_CREDENTIALS}`,
    method: RequestTypes.get,
}

export const getBalances = {
    link: `${BILLING_API_PREFIX}${BILLING_BALANCES}`,
    method: RequestTypes.get,
}

export const getPaymentHistoryLimited = {
    link: `${AUDIT_API_PREFIX}${HISTORY_PAYMENT}`,
    method: RequestTypes.post,
}

export const getPdfFile = {
    link: `${BILLING_API_PREFIX}${CREDENTIALS_DOWNLOAD}`,
    method: RequestTypes.post,
}

export const getPackages = {
    link: `${BILLING_API_PREFIX}${BILLING_PACKAGES}`,
    method: RequestTypes.get,
}

export const getLimitVolume = {
    link: `${EXTENSION_API_PREFIX}extension/limits/volume`,
    method: RequestTypes.get,
}
export const getIssueLimitSpVolume = {
    link: `${EXTENSION_API_PREFIX}extension/limits/issue/volume`,
    method: RequestTypes.get,
}
export const getRepaymentLimitSpVolume = {
    link: `${EXTENSION_API_PREFIX}extension/limits/repayment/volume`,
    method: RequestTypes.get,
}
export const getPaymentOperationsFile = {
    link: `${EXTENSION_API_PREFIX}${PAYMENT_OPERATIONS}`,
    method: RequestTypes.post,
}
export const getCalculatorTariffs = {
    link: `${BILLING_API_PREFIX}${CALCULATOR_TARIFFS}`,
    method: RequestTypes.get,
}
